import styled, { css } from 'styled-components'

const StyledLinkStyles = css<{ $color?: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme, $color }) => $color ?? theme.forecast.secondaryText};
`

export const ExternalLink = styled.a<{ $color?: string }>`
  ${StyledLinkStyles}
`
